import React, { useEffect } from "react";
import themes from "./themes";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { useSelector } from "react-redux";
import "./assets/scss/styles.scss";
import PageRoute from "./Components/Routers/PageRoute";
import SnackbarCompo from "./Components/Ui_elements/Snackbar";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useGlobalSmartNavigation } from "./Helper/useGlobalSmartNavigation";
// Import favicons
import dosinaFavicon from "./assets/logo/dosina-favicon.ico";
import beconnectedFavicon from "./assets/logo/beconnected-favicon.ico";
import kanhasoftFavicon from "./assets/logo/kanhasoft-icon.png";

function App() {
  const customization = useSelector((state) => state.root.customization);
  const iFkUserTypeId = useSelector(
    (state) => state?.root?.authUser?.user?.iFkUserTypeId || localStorage.getItem("userType")
  );

  // Initialize global smart navigation
  useGlobalSmartNavigation();

  useEffect(() => {
    const hostname = window.location.hostname;

    // Set favicon based on clientKey
    let faviconHref;
    if (hostname.includes("tms.dosina.no")) {
      faviconHref = dosinaFavicon;
    } else if (hostname.includes("tms.beconnected.no")) {
      faviconHref = beconnectedFavicon;
    }else if(hostname.includes("devtmsapp.beconnected.no")){
      faviconHref = kanhasoftFavicon
    }
     else {
      faviconHref = kanhasoftFavicon;
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.href = faviconHref;
    } else {
      const favicon = document.createElement("link");
      favicon.rel = "icon";
      favicon.type = "image/x-icon";
      favicon.href = faviconHref;
      document.head.appendChild(favicon);
    }
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <DndProvider backend={HTML5Backend}>
        <CssBaseline />
        <ThemeProvider theme={themes(customization)}>
          <SnackbarCompo />
          <PageRoute id={iFkUserTypeId} />
        </ThemeProvider>
      </DndProvider>
    </StyledEngineProvider>
  );
}

export default App;
